/* src/app/shared/components/privacy-dialog/privacy-dialog.component.scss */
.pvd-header {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid #e5e7eb;
  margin: 0 !important;
}
.pvd-header__title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  font-family: "Inter Tight", sans-serif;
}
.pvd-header__close {
  color: #9ca3af;
  flex-shrink: 0;
  transition: color 0.15s;
}
.pvd-header__close:hover {
  color: #0f172a;
}
.pvd-body {
  padding: 20px 24px !important;
  font-family:
    "Inter Tight",
    -apple-system,
    sans-serif;
  font-size: 13.5px;
  color: #374151;
  line-height: 1.7;
  max-height: 60vh;
}
.pvd-body p {
  margin: 0 0 12px;
}
.pvd-section {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 22px 0 10px;
  padding-bottom: 6px;
  border-bottom: 2px solid #f59e0b;
  display: inline-block;
}
.pvd-list {
  margin: 0 0 12px;
  padding-left: 20px;
}
.pvd-list li {
  list-style-type: disc;
  margin-bottom: 5px;
  color: #374151;
}
.pvd-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
  font-size: 13px;
}
.pvd-table th {
  background: #f3f4f6;
  color: #374151;
  font-weight: 600;
  text-align: left;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.pvd-table td {
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  vertical-align: top;
}
.pvd-table td:first-child {
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  width: 35%;
}
.pvd-table tr:nth-child(even) td {
  background: #f3f4f6;
}
.pvd-table--wide td:first-child {
  width: 40%;
}
.pvd-url {
  color: #f59e0b;
  font-weight: 500;
}
.pvd-actions {
  padding: 12px 24px 16px !important;
  border-top: 1px solid #e5e7eb;
  justify-content: flex-end !important;
  margin: 0 !important;
}
.pvd-accept {
  background: #f59e0b !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-family: "Inter Tight", sans-serif;
  font-weight: 600;
  font-size: 13.5px;
  border-radius: 8px !important;
  height: 38px !important;
  padding: 0 20px !important;
  transition: background 0.15s !important;
}
.pvd-accept:hover {
  background: #d97706 !important;
}
/*# sourceMappingURL=privacy-dialog.component.css.map */
